import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCloudStyle0 = cosmosIconCss;

const CosmosIconCloud$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCloud extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ee632aa5b82d1bc4a7d33dfeaf7a745ef92caf8a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '39e7d9d494c7e522cdd98c029d28ccd553f9b6b6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '04a02e77c3fb21d0fcad53138d6b76c0ca75b81b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5.002h7.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H17a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.5v-9h-7.19a.5.5 0 0 1-.44-.28L10 4.502H3.5v6.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-7.5a.5.5 0 0 1 .5-.5h8.14a.5.5 0 0 1 .49.28l.87 1.72Zm2.5 10.887a2 2 0 0 1-1.944 2h-8.5v-.008a2.25 2.25 0 1 1 .777-4.416 3.5 3.5 0 1 1 6.962.552 2 2 0 0 1 2.705 1.872Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCloudStyle0; }
}, [1, "cosmos-icon-cloud", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-cloud"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-cloud":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCloud$1);
            }
            break;
    } });
}

const CosmosIconCloud = CosmosIconCloud$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCloud, defineCustomElement };
